/* eslint-disable no-dupe-keys */
export default {
  inserting_gun_start_record: {
    name: '即插即充启动记录',
    // 属性（一般与对象内容匹配）
    prop: {
      charger: '充电桩',
      plate_number: '车牌',
      plate_number_recognition_time: '车牌识别时间',
      car: '车辆',
      user: '用户',
      user_id: '用户',
      service_provider: '运营商',
      service_provider_id: '运营商',
      verify_result: '结果',
      description: '描述',
      created_at: '启动时间',
      updated_at: '更新时间',
      time_diff: '入库→插枪'
    },
    // Enum的属性
    verify_results: {
      success_start: '成功',
      balance_not_enough: '余额不足',
      charger_forbidden: '无权在此桩充电',
      car_not_exist: '车辆未绑定',
      unrecognized_license_plate: '未识别到车牌',
      charger_start_failed: '桩启动失败',
      operation_delay: '停车超时后插枪',
      operation_serious_delay: '严重超时后插枪'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询车牌/桩编号/站名'
    },
    // 详情页标签
    labels: {
      success_count: '启动成功数',
      fail_count: '启动失败数',
      car_not_exist_count: '未认证车辆启动数'
    },
    tips: {
      abnormal_time_diff: '占位时间过长 或 摄像头识别已停止'
    }
  }
}
